export const summariesAndStockPriceVariantMapper = (
  stockPriceVariant,
  summariesVariant
) => {
  const { id, price, isInStock, isLowInStock, seller, source } =
    stockPriceVariant;

  const {
    name,
    sizeId,
    brandSize,
    sizeOrder,
    sku,
    isAvailable,
    colourWayId,
    colour,
    isPrimary,
    ean,
  } = summariesVariant;

  return {
    variantId: id,
    name,
    sizeId,
    size: brandSize,
    sizeOrder,
    sku,
    isAvailable,
    colourWayId,
    colour,
    isPrimary,
    ean,
    price: {
      current: price?.current,
      previous: price?.previous,
      rrp: price?.rrp,
    },
    isInStock,
    isLowInStock,
    seller,
    source,
  };
};
